import CustomAmplitudeClient from "../../js/custom-amplitude-client.8d2468912b6f.js";

const modal = document.getElementById("verify-estimate-modal");
const verifyEstimateButtons = document.querySelectorAll(
  "[data-action='verify-estimate-modal']",
);
const pageConfig = JSON.parse(
  document.getElementById("page-config").textContent,
);
const customAmplitudeClient = new CustomAmplitudeClient(
  pageConfig.analyticsUrl,
);

verifyEstimateButtons.forEach((button) => {
  button.addEventListener("click", () => {
    modal.showModal();
    customAmplitudeClient.trackStartContactProvider("pet-details-page");
  });
});

// Track when contact buttons are clicked
const contactButtons = document.querySelectorAll(
  "#verify-estimate-modal .contact-provider-button",
);
contactButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    const contactMethod = e.currentTarget.dataset.method;
    customAmplitudeClient.trackEngageContactProvider(
      contactMethod,
      "pet-details-page",
    );
  });
});
